module.exports = "/lucky-balls/img/jackpot/015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/015.png
// module id = 1115
// module chunks = 0